module.exports = __webpack_public_path__ + "static/media/cliente-plante-bem.e220bb80.webp";